import { render, staticRenderFns } from "./TeamEdit.vue?vue&type=template&id=bd2e0e18&scoped=true&"
import script from "./TeamEdit.vue?vue&type=script&lang=js&"
export * from "./TeamEdit.vue?vue&type=script&lang=js&"
import style0 from "./TeamEdit.vue?vue&type=style&index=0&id=bd2e0e18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd2e0e18",
  null
  
)

export default component.exports